import stylesheet from './Table.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTTable extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const tableContainer = document.createElement('div');
        tableContainer.classList.add('nxt-table-container')
        this.cloneDefaultSlotContentIntoContainer(tableContainer)
        return tableContainer;
    }

}

customElements.define('nxt-table', NXTTable);
